<template>
  <div style="overflow:hidden;height:100%;position:relative;">
    <div class="flex-wrap" style="height:40px;display:flex;padding:0 5px;">
        <Input v-model="search" placeholder="搜索" style="width:200px;" />
    </div>
    <div style="height:calc(100% - 40px);padding:0 5px;overflow:hidden;position:relative;">

    <BaseTable
    :columns="columns"
    :data="filteredItems"
    border
    />
  </div>

  </div>
</template>

<script>
export default {
  name: 'Certs',
  data() {
    return {
      items: [],
      loading: false,
      search: '',
      columns: [
        {
          type: 'index',
          title: '序号',
          width: 60,
        },
        {
          title: '证书类型',
          key: 'type',
          width: 120,
        },
        {
          title: '证书名称',
          key: 'name',
        },

        {
          title: '证书状态',
          width: 120,
          key: 'status',
        },
        {
          title: '发证时间',
          key: 'accquired_at',
          width: 120,
          type: 'date',
        }, {
          title: '到期时间',
          key: 'expired_at',
          width: 120,
          type: 'date',
        }, {
          title: '操作',
          key: 'action',
          minWidth: 120,
          render: (h, params)=>{
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                },
                on: {
                  click: ()=>{
                    this.editItem(params.row);
                  },
                },
              }, '下载'),
            ]);
          },
        },
      ],
    };
  },
  computed: {
    filteredItems() {
      return this.items.filter((item)=>item.name.includes(this.search));
    },
  },
  mounted() {
    this.$api.afterLogin(()=>{
      this.getData();
    });
  },
  methods: {
    getData() {
      this.loading = true;
      this.$api.get('/admin/certs').then((res)=>{
        this.items = res.data;
      }).catch((e)=>{
        this.Erro(e);
      }).finally(()=>{
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="less">

</style>
